module.exports = __webpack_public_path__ + "img/icon_acc_logout.746c1ff2.svg";